<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card-title>
      OT Bill Head List
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>

      <v-col cols="12" sm="6" md="4">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              label="Select Date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            @input="menu2 = false"
            @click:date="dateSelect"
            :max="nowDate"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <template>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </template>
      </v-col>
      <v-col cols="12" sm="6" md="1">
        <template>
          <v-row align="center" justify="space-around">
            <v-btn
              depressed
              color="primary"
              append-icon="mdi-printer"
              @click="printList"
              >Print
            </v-btn>
          </v-row>
        </template>
      </v-col>
    </v-card-title>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="desserts"
        class="elevation-1"
        :search="search"
        :actions="actions"
        dense
        mobile-breakpoint="0"
        disable-pagination
        :hide-default-footer="true"
        :loading="loadingstatus"
        loading-text="Loading... Please wait"
      >
        <!-- <template v-slot:item.opp_status="{ item }">
          <v-chip :color="getColor(item.opp_status)" dark>
            {{ item.opp_status.toUpperCase() }}
          </v-chip>
        </template>
        <template v-slot:item.paid_amount="{ item }">
          <div class="d-flex justify-center font-weight-black">
            {{ b_number_format(item.paid_amount) }}
          </div>
        </template>
        <template v-slot:item.hospital_amount="{ item }">
          <div class="d-flex justify-center font-weight-black">
            {{ b_number_format(item.hospital_amount) }}
          </div>
        </template>
        <template v-slot:item.doctor_amount="{ item }">
          <div class="d-flex justify-center font-weight-black">
            {{ b_number_format(item.doctor_amount) }}
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip top v-if="item.opp_status == 'open'">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                @click="ot_details(item)"
                dark
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                color="orange"
                label
                outlined
                small
                ><v-icon left> mdi-chevron-double-right </v-icon>
              </v-chip>
            </template>
            <span>OT Registration Details</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                @click="ot_refund(item)"
                dark
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                open
                color="primary"
                label
                outlined
                small
                ><v-icon left> mdi-undo-variant </v-icon>
              </v-chip>
            </template>
            <span>Refund to Patient</span>
          </v-tooltip>
        </template> -->
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../../js/setup";
export default {
  data() {
    return {
      search: "",
      date: new Date().toISOString().substr(0, 10),
      nowDate: new Date().toISOString().substr(0, 10),
      menu2: false,
      loadingstatus: true,
      headers: [

        { text: "Head Name", value: "ledger_name" },
        { text: "Single Eye", value: "amount" },
        { text: "Ledger Type", value: "ledger_type" },
        { text: "OT Type", value: "operation_type" },
        { text: "Action", value: "actions", sortable: false },
      ],
      actions: [
        {
          type: "edit",
          key: ["Description"],
          func: this.updatePayment,
          icon: "edit",
        },
      ],

      desserts: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "OT Bill Head",
          disabled: true,
          href: "patients",
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.initialize(this.date);
    // console.log(this.$store.getters.getUserName);
    // console.log(atshq.defaults.headers.common.api_URL);
  },
  methods: {
    initialize(date) {
      atshq
        .get("/ot-module/ot-bill-head?date=" + date)
        .then((response) => {
          this.desserts = response.data.data;
          this.loadingstatus = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    b_number_format(n) {
      return n.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    },
    getColor(status) {
      if (status == "open") return "orange";
      else return "green";
    },
    printList() {
      window.open(this.returnUrl + "/printdoc/otbill/" + this.date);
    },
    dateSelect(date) {
      this.loadingstatus = true;
      this.initialize(date);
    },
    ot_details(item) {
      window.location.href = "/ot-registration/" + item.registration_no;
    },
    ot_refund(item) {
      window.location.href = "/otbill-refund/" + item.registration_no;
    },
  },
};
</script>